/**
 * Contact: the headline is the route's own line; faqEyebrow, faqSub and the form copy are the plate
 * and the form beside it. Change the words here, never in the components.
 */
export const contactPage = {
  eyebrow: 'Contact',
  titleThin: 'Tell me what',
  titleBold: 'you need built.',
  lede: 'Read the answers first. If your question is still open, write and I will reply with a plan or a straight no.',
  faqEyebrow: 'FAQs',
  faqTitle: 'Quick answers',
  faqSub: 'Still have one? Write below.',
  cardTitle: 'Send me a message',
  cardBody: 'What do you need? What are you using today? Two or three lines is enough.',
}

/** The form. Until a backend is wired, Send opens the visitor's own mail app with the message laid out. */
export const contactForm = {
  first: 'First name',
  last: 'Last name',
  email: 'Email',
  message: 'Tell me more about your project',
  phFirst: 'First name',
  phLast: 'Last name',
  phEmail: 'you@yourbusiness.com',
  phMessage: 'What do you need? What are you using today? What does a good result look like?',
  send: 'Send message',
  hint: 'This form opens your own email app. Nothing is sent to or stored on this site.',
  error: 'Add your name, a real email, and a short note.',
  sentTitle: 'Your mail app has it.',
  sentBody: 'The message is laid out and addressed. Press send there and it is on its way.',
  // The fallback for a visitor whose browser has no mail app set up.
  noMailApp: 'No mail app opened? Write to',
  copy: 'Copy message',
  copied: 'Copied',
  again: 'Write another',
}
